// src/components/Process/Process.js
import React from 'react';
import styled from 'styled-components';
import { fadeIn } from '../shared/animations';
import SectionTitle from '../shared/SectionTitle';

// Styled Components
const ProcessContainer = styled.section.attrs(() => ({
  id: 'process' // <--- Aqui está a mágica
}))`
  padding: 100px 20px;
  background: white;
  position: relative;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;


const ProcessSteps = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 50px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(to bottom, #151c48, #5ab9d3);
    border-radius: 2px;
    
    @media (max-width: 768px) {
      left: 30px;
    }
  }
`;

const ProcessStep = styled.div`
  display: flex;
  margin-bottom: 40px;
  position: relative;
  animation: ${fadeIn} 0.6s ease-out forwards;
  animation-delay: ${props => props.delay * 0.2}s;
  opacity: 0;
`;

const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #151c48, #5ab9d3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  flex-shrink: 0;
  margin-right: 30px;
  box-shadow: 0 10px 30px rgba(90, 185, 211, 0.3);
  
  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    margin-right: 20px;
  }
`;

const StepContent = styled.div`
  flex: 1;
  padding-top: 10px;
`;

const StepTitle = styled.h3`
  font-size: 1.5rem;
  color: #151c48;
  margin-bottom: 10px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const StepDescription = styled.p`
  color: #5f6c84;
  line-height: 1.6;
`;

// Data - Pode ser movido para um arquivo separado se necessário
const STEPS_DATA = [
  {
    number: '1',
    title: 'Cadastro e Perfil',
    description: 'Crie seu perfil informando seus objetivos, necessidades e orçamento para a realocação em Portugal.'
  },
  {
    number: '2',
    title: 'Match com Profissionais',
    description: 'Nosso sistema conecta você automaticamente aos melhores consultores e empresas de relocation para seu perfil.'
  },
  {
    number: '3',
    title: 'Propostas Personalizadas',
    description: 'Receba propostas detalhadas dos profissionais, com serviços, prazos e valores claramente especificados.'
  },
  {
    number: '4',
    title: 'Escolha e Contratação',
    description: 'Compare as opções, converse diretamente com os profissionais e escolha a melhor solução para você.'
  },
  {
    number: '5',
    title: 'Acompanhamento e Suporte',
    description: 'A Realoca Fácil acompanha todo o processo para garantir que tudo corra conforme o planejado.'
  }
];

// Componente de Step individual para melhor reutilização
const ProcessStepItem = ({ delay, number, title, description }) => (
  <ProcessStep delay={delay}>
    <StepNumber>{number}</StepNumber>
    <StepContent>
      <StepTitle>{title}</StepTitle>
      <StepDescription>{description}</StepDescription>
    </StepContent>
  </ProcessStep>
);

// Componente Principal
const Process = () => {
  return (
    <ProcessContainer>
      <SectionTitle>Como Funciona Nosso Processo</SectionTitle>
      <ProcessSteps>
        {STEPS_DATA.map((step, index) => (
          <ProcessStepItem
            key={step.title}
            delay={index}
            number={step.number}
            title={step.title}
            description={step.description}
          />
        ))}
      </ProcessSteps>
    </ProcessContainer>
  );
};

export default Process;